import React from 'react';
import map from 'lodash/map';
import isEmpty from 'lodash/isEmpty';
import LazyLoad from 'react-lazyload';

import ProductCard from './ProductCard';
import styles from './ProductCards.module.css';

const ProductCards = ({ products, isLoading }) => {
  if (isLoading)
    return (
      <div className={styles.noData}>
        <p className={styles.loading}>Loading Data...</p>
      </div>
    );

  if (isEmpty(products))
    return (
      <div className={styles.noData}>
        <i className="fal fa-ghost dark" />
        <p className={styles.title}>No Products Match Your Search</p>
        <p className={styles.description}>
          Please clear your search and try again.
        </p>
      </div>
    );

  return (
    <ul className={styles.container}>
      {map(products, (product) => {
        const {
          legacyPostId,
          isPublic,
          productName,
          brandName,
          sku,
          imageUrl,
        } = product;
        return (
          <LazyLoad key={legacyPostId} height={282} once>
            <ProductCard
              legacyPostId={legacyPostId}
              productName={productName}
              brandName={brandName}
              sku={sku}
              imageUrl={imageUrl}
              isPublic={isPublic}
            />
          </LazyLoad>
        );
      })}
    </ul>
  );
};

export default ProductCards;
